import React from "react";

const NewTab = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1816 7.21636C13.1816 7.21636 13.1816 12.1384 13.1816 12.7423C13.1816 13.3463 12.7589 13.7539 12.0946 13.7539C11.4302 13.7539 5.7231 13.7539 5.14937 13.7539C4.57563 13.7539 4.0019 13.301 4.0019 12.7423C4.0019 12.1837 4.0019 6.11796 4.0019 5.70653C4.0019 5.2951 4.51524 4.55906 5.14937 4.55906C5.78349 4.55906 10.8565 4.55906 10.8565 4.55906"
        stroke="white"
        strokeWidth="1.35884"
      />
      <path
        d="M16.565 1.99958C16.565 1.59933 16.2405 1.27487 15.8403 1.27487L9.31781 1.27487C8.91756 1.27487 8.59309 1.59933 8.59309 1.99958C8.59309 2.39983 8.91756 2.7243 9.31781 2.7243L15.1155 2.7243L15.1155 8.52203C15.1155 8.92228 15.44 9.24675 15.8403 9.24675C16.2405 9.24675 16.565 8.92229 16.565 8.52204L16.565 1.99958ZM10.0945 8.77026L16.3527 2.51204L15.3278 1.48713L9.06958 7.74536L10.0945 8.77026Z"
        fill="white"
      />
    </svg>
  );
};

export default NewTab;
